import React, { Component } from 'react';
import './App.css';
import LandingHome from "./Components/LandingPage/LandingHome/LandingHome";
import Menu from "./Components/LandingPage/Menu/Menu";
import Service from "./Components/ServicesPage/Service/Service";
import serviceData from './StaticData/servicesDataJSON';
import Footer from "./Components/Footer/Footer";
import ContactFAB from "./Components/ContactFAB/ContactFAB";
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import ContactForm from "./Components/ContactForm/ContactForm";

class App extends Component {


    state = {
        currentService : null
    };

    changeService = props => {
        console.log(props);
        this.setState({"currentService":props});
        window.scrollTo(0, 0);
    };

    returnToHome = props => {
        this.setState({"currentService":null});
        window.scrollTo(0, 0);
    };

    
    render() {


        let body = <LandingHome changeService={this.changeService}/>;

        if(this.state.currentService!=null){
            body = <Service data={serviceData[this.state.currentService]}/>;
        }

        return (
            <Router>
                <switch>
                    <Route path="/" exact render={props =>
                        <div className="App">
                            <Menu changeService={this.changeService} returnToHome={this.returnToHome}/>
                            {body}
                            <Footer/>
                            <ContactFAB/>
                        </div>
                    } />

                    <Route path="/trail" exact component={ContactForm} />
                </switch>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js